(ns hai.ui.components.error
  "Component(s) for displaying errors in a friendly way"
  (:require
   [hai.ui.components :as c]
   [hai.ui.components.link :as link]
   [hai.ui.icons :as icons]
   [lambdaisland.ornament :as o]
   [reagent.core :as reagent]))

(o/defstyled error-card :div
  "Friendly-ish error card. By default shows a blue triangle with an exclamation
  point, the message 'Something went wrong', and a button to reload the page. A
  faded link in the bottom right corner allows expanding to see the error
  message / details."
  :flex :flex-col :flex-auto
  [:.rt-Card :flex :flex-col :flex-auto :items-center :gap-8 :justify-center]
  [:.msg :text-2xl]
  [:.warning
   [:svg :w-20 :h-20  {;; The icon SVG contains some whitespace at the
                       ;; top/bottom which messes up the layout gaps
                       :margin-top "-0.5rem"
                       :margin-bottom "-0.5rem"
                       :fill c/--accent-10}]]
  [:.rt-Button {:fill c/--accent-contrast}]
  [link/faded :absolute :bottom-0 :right-0 :mx-4 :my-2]
  ([error-message]
   (reagent/with-let [show-details? (reagent/atom false)]
     (if @show-details?
       [c/Card
        [:pre (if (string? error-message) error-message (pr-str error-message))]
        [c/Button
         {:on-click #(js/window.location.reload)}
         [icons/filled-replay]
         "Reload"]]
       [c/Card
        [:div.warning [icons/filled-warning_amber]]
        [:div.msg "Something went wrong"]
        [c/Button
         {:on-click #(js/window.location.reload)}
         [icons/filled-replay]
         "Reload"]
        [link/faded {:on-click #(reset! show-details? true)} "details"]]))))
